import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import { router } from 'expo-router';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { i18n } from '@/utils/i18n';

import Text from '../Text';

interface ImpactMapPillProps {
  npoType: 'charity' | 'church';
}

const ImpactMapPill = ({ npoType }: ImpactMapPillProps) => {
  //Locales
  const map = i18n.t('mix.map');

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={() => {
        router.navigate({
          pathname: '/profile/individual/impact/map',
          params: {
            npoType: npoType
          }
        });
      }}>
      <FontAwesome5 name="map-marked-alt" size={16} color="white" />
      <Text style={styles.text} fontWeight="700">
        {map}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'black',
    borderRadius: 20,
    borderColor: 'white',
    borderWidth: 1,
    flexDirection: 'row',
    columnGap: 10,
    paddingHorizontal: 20,
    paddingVertical: 7,
    position: 'absolute',
    bottom: 30,
    alignSelf: 'center'
  },
  text: {
    color: 'white',
    fontSize: 14
  }
});

export default ImpactMapPill;
